/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S2_TitleInputs */

const en_fc_tut_s2_title = /** @type {(inputs: Fc_Tut_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn the workspace`)
};

/**
* | output |
* | --- |
* | "Learn the workspace" |
*
* @param {Fc_Tut_S2_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s2_title = /** @type {((inputs?: Fc_Tut_S2_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S2_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s2_title(inputs)
});
export { fc_tut_s2_title as "fc.tut.s2.title" }